import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, TextField } from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import DialogTransition from "@icarius-common/dialogTransition";
import { employeeCodeChangeAction } from "@icarius-pages/myPeople/actions";
import { getRutIsValid } from "@icarius-utils/types";
import { useSelector } from "react-redux";
import { getCountry } from "@icarius-app/selectors";

const gridStyle = { height: 75, padding: "0px 10px" };

const CodeDialog = (props) => {
    const { open, isLoading, employees, handleAfterSubmit, handleClose } = props;

    const [code, setCode] = useState("");

    const dispatch = useDispatch();
    const country = useSelector(getCountry);

    const handleSubmit = () => {
        if (country === "CL") {
            // validar RUT
            if (!getRutIsValid(code)) {
                dispatch(openSnackbarAction({ msg: getLocalizedString("invalidRut"), severity: "error" }));
                return;
            }
        }

        if (code.length > 0) {
            dispatch(
                employeeCodeChangeAction({
                    old_codemp: employees[0].code,
                    new_codemp: code,
                })
            ).then((resp) => {
                if (resp.status === 200) {
                    handleAfterSubmit(resp?.data?.showAlert);
                }
                handleClose();
            });
        } else {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustEnterNewEmployeeCode"), severity: "warning" }));
        }
    };

    if (isLoading) return null;

    return (
        <Dialog
            open={open}
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            maxWidth={"sm"}
            fullWidth={true}
        >
            <div className={"dialog-container"}>
                <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                    {getLocalizedString("employeeCodeChange")}
                    <DialogTitleDivider />
                </DialogTitle>
                <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
                <DialogContent>
                    <Grid container>
                        <Grid container item alignItems="center" xs={12} style={gridStyle}>
                            <TextField
                                required
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("code")}
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                inputProps={{ maxLength: 20 }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
                    <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("accept")} />
                </DialogActions>
            </div>
        </Dialog>
    );
};

export default CodeDialog;
